<template>
    
    <div class="group-bg-main">
        <div class="st sec-banner-main bg-banner sec-attractions bg-77vote mb-0">
            <div class="container container-1360">
                <div class="position-relative">
                    <div class="box-title">
                        <h1 class="font-display mb-0"><span class="gd-hl">แหล่งท่องเที่ยว<br> UNSEEN อื่นๆ ที่ว้าวไม่แพ้กัน</span></h1>
                        <!-- <h3 class="font-display mb-0"><span class="gd-hl"></span></h3> -->
                        <!-- <h1 class="font-display font-second"><span class="gd-hl"></span></h1> -->
                        <!-- <h1 class="font-display mb-0"><span class="gd-hl">แหล่งท่องเที่ยวสุดว้าว</span></h1>
                        <h3 class="font-display font-second"><span class="gd-hl">Unseen New Chapters</span></h3> -->
                        <!-- <h4><b>ร่วมติดตามผล<br class="d-md-none d-block">แหล่งท่องเที่ยว<br class="d-md-block d-none">Unseen New Chapters <br class="d-md-none d-block">ปักหมุดมุมใหม่ เปิดไทยมุมต่าง</b></h4> -->
                        <h4 class="text-uppercase"><b>Unseen New Chapters<br class="d-md-block d-none"> ปักหมุดมุมใหม่ เปิดไทยมุมต่าง</b></h4>
                        <!-- <p>ที่จะประกาศพร้อมกันทั่วประเทศ <span style="display: inline-block;">วันอังคารที่ 27 มิถุนายน 2566</span></p> -->
                    </div>
                </div>
            </div>
        </div>
        <div class="st sec vote77 pd">
            <div class="container container-1360">
                <div class="position-relative">
                    <div class="sec-tab bg-gd">
                        <ul ref="tabList">
                            <li class="tab-list" @click="activateTab('north')" :class="{ active: activeTab === 'north' }">
                                <a href="javascript:void(0)" class="tab-a"><span>ภาคเหนือ</span><span
                                        :class="northVote ? '' : 'opacity-0 d-none'" class="region-voted">VOTED</span> </a>
                            </li>
                            <li class="tab-list" @click="activateTab('central')"
                                :class="{ active: activeTab === 'central' }">
                                <a href="javascript:void(0)" class="tab-a"><span>ภาคกลาง</span><span
                                        :class="centralVote ? '' : 'opacity-0 d-none'" class="region-voted">VOTED</span> </a>
                            </li>
                            <li class="tab-list" @click="activateTab('northeast')"
                                :class="{ active: activeTab === 'northeast' }">
                                <a href="javascript:void(0)" class="tab-a"><span>ภาคอีสาน</span><span
                                        :class="northeastVote ? '' : 'opacity-0 d-none'" class="region-voted">VOTED</span> </a>
                            </li>
                            <li class="tab-list" @click="activateTab('eastern')"
                                :class="{ active: activeTab === 'eastern' }">
                                <a href="javascript:void(0)" class="tab-a"><span>ภาคตะวันออก</span><span
                                        :class="easternVote ? '' : 'opacity-0 d-none'" class="region-voted">VOTED</span> </a>
                            </li>
                            <li class="tab-list" @click="activateTab('south')" :class="{ active: activeTab === 'south' }">
                                <a href="javascript:void(0)" class="tab-a"><span>ภาคใต้</span><span
                                        :class="southVote ? '' : 'opacity-0 d-none'" class="region-voted">VOTED</span> </a>
                            </li>
                        </ul>
                        <div v-if="historyData != null || historyData != undefined" class="tab-my-rights">
                            <div class="tmr-l">
                                <div class="tmr-l-1">สิทธิ์โหวต</div>
                                <div class="tmr-l-2">ของคุณเหลือ</div>
                            </div>
                            <div class="tmr-c txt-w-lg" v-if="playStatus == 0">{{ profileData.credit_vote }}</div>
                            <div class="tmr-c txt-w-lg" v-if="playStatus > 0">0</div>
                            <div class="tmr-r">สิทธิ์</div>
                        </div>
                    </div>
                    <div class="sec-votelist">
                        <div class="tab-content">
                            <template v-if="Object.keys(travelListZone.zones)">
                                <template v-for="(zones, index) in travelListZone.zones " :key="zones.id">
                                    <Transition name="fade">
                                       
                                        <div class="list-tab" :class="[activeTab === index ? 'active' : '' ,isVote(index) ? 'isvote' : '' ]">
                                            <div
                                                class="row g-custom g-3 row-cols-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-4 row-cols-xxl-5 g-4 g-xl-5">
                                                <div class="col" v-for="(zone, index) in zones " :index="index" :key="zone.id">
                                                    <div class="card card-vote " :class="itemVote(zone.region_en,zone.id) ? 'itemIsVote' : '' " >
                                                        <div class="card-img" >
                                                            <!-- <div class="rating txt-w-lg">{{ index+1  }}</div> -->
                                                            <!-- <img :src="`${request('../assets/img/77-attractions/' + replaceExtension(zone.image_cover))}`" alt="" class="fw"> -->
                                                           
                                                            <img 
                                                                @click="handlePopContentClick(zone.id,
                                                                zone.location_name,
                                                                zone.location,
                                                                zone.province_th,
                                                                zone.region_th,
                                                                zone.detail,
                                                                replaceExtension(zone.image_cover),
                                                                zone.images,
                                                                zone.vote,
                                                                zone.region_en,
                                                                zone.tel,
                                                                zone.location_link)"
                                                                :src="require(`../assets/img/77-attractions/${replaceExtension(zone.image_cover)}`)"
                                                                alt="" class="fw">
                                                            <a v-if="winW <= 1199" href="javascript:void(0)" @click="handleVote(zone.id,replaceExtension(zone.image_cover),zone.location_name, zone.province_th,zone.region_th)" class="card-like card-action-default btn-on-card">
                                                                <span><img src="../assets/img/skin/icon-heart-vote.svg" class="svg"
                                                                    alt=""><span class="vote-num">{{ zone.vote >= 1000 ? (Math.round(zone.vote)).toLocaleString() : Math.round(zone.vote) }}</span><span
                                                                    class="vote-txt">VOTE</span></span>
                                                            </a>
                                                        </div>
                                                        <div class="card-body px-0 pb-0">
                                                            <div class="card-cont"  @click="handlePopContentClick(zone.id,
                                                                zone.location_name,
                                                                zone.location,
                                                                zone.province_th,
                                                                zone.region_th,
                                                                zone.detail,
                                                                replaceExtension(zone.image_cover),
                                                                zone.images,
                                                                zone.vote,
                                                                zone.region_en,
                                                                zone.tel,
                                                                zone.location_link)">
                                                                <h6 ref="cardContentLocation"><b v-html="zone.location_name"></b>
                                                                </h6>
                                                                <p class="gray-dark"><small>จ.{{zone.province_th }} {{ zone.region_th }}</small></p>
                                                            </div>
                                                            <a  v-if="winW > 1199" href="javascript:void(0)" @click="handleVote(zone.id,replaceExtension(zone.image_cover),zone.location_name, zone.province_th,zone.region_th), handleClick('Vote-Thumb',zone.location_name)"
                                                                class="card-like card-action-default">
                                                                <span><img src="@/assets/img/skin/icon-heart-vote.svg"  class="svg" alt=""><span class="vote-num">{{ zone.vote >= 1000 ? (Math.round(zone.vote)).toLocaleString() : Math.round(zone.vote) }}</span><span class="vote-txt">VOTE</span></span>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Transition>
                                </template>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    

    </div>
    <popUpVoteList @connect-api="handleVoteError" :style="voteError == true ? 'display: none;' : ''" @vote-success="handleVoteSuccess" @session-timeout="handleSession" v-if="voteShow == true" :locationTicker="locationTicker" :userId="profileData.id" v-on:close-popup="[voteShow = false , show = false]" v-on:close-popupVote="[voteShow = false]" @button-clicked="autoTab" @after-vote="afterVote"></popUpVoteList>

    <template v-if="show" >
        <Transition name="fade "  mode="out-in">
            <popupDetail @vote-clicked="handleVoteClicked"  @vote-start="handleVoteStart"  v-on:close-popup="show = false, this.$root.metaDefault()"  :popupContArray="popupContArray">
           
            </popupDetail>
        </Transition>
    </template>


    <loadPageComponent v-if="isloade" class="loadpage-com" :class="isloade == true ? isActive : isActive = '' "></loadPageComponent>
    <loadApiComponent v-if="isloadeApi" class="loadpage-com loadApi " :class="isloadeApi == true ? isActive : isActive = '' "></loadApiComponent>
    <popupError v-if="voteError"></popupError>

    <popupDup v-if="popupVoteDup"></popupDup>
    <popupSession v-if="popSession"></popupSession>
    
</template>

<script>
/* eslint-disable */


// STORE
import { setFunction  } from '@/global'
import { mapState, mapGetters } from 'vuex';
import popupDetail from '@/components/popup/popupDetail.vue';
import popUpVoteList from '@/components/popup/popUpVoteList.vue';
import popupError from '@/components/popup/popupError.vue';
import popupDup from '@/components/popup/popupVoteDup.vue';
import loadPageComponent from '@/components/loadPageComponent.vue';
import loadApiComponent from '@/components/loadPageComponent.vue';
import popupSession  from '@/components/popup/popupCheclSession.vue';
import Cookies from 'js-cookie';
import { $route } from 'vue-router'
import { clickTracking } from '@/main';
import axios from 'axios';
export default {
    name: 'AttractionsView',
    components: { popupDetail, popUpVoteList,loadPageComponent,popupError,loadApiComponent,popupDup,popupSession },
    data() {
        return {
            voteError: false,
            isActive:'active',
            isloade:true,
            isloadeApi:false,
            isLoading: true,
            intervalId: null,
            activeTab: 'north',
            tabs: [
                { label: 'ภาคเหนือ', label_en: 'north' },
                { label: 'ภาคกลาง', label_en: 'central' },
                { label: 'ภาคอีสาน', label_en: 'northeast' },
                { label: 'ภาคตะวันออก', label_en: 'eastern' },
                { label: 'ภาคใต้', label_en: 'south' },
            ],
            show: false,
            checkId: false,
            voteShow: false,
            cardContent: '',
            cardImageArray: [],
            images: [
                'https://via.placeholder.com/450',
                'https://via.placeholder.com/450',
                'https://via.placeholder.com/450',
                'https://via.placeholder.com/450',
                'https://via.placeholder.com/450'
            ],
            galleryTop: null,
            galleryThumbs: null,
            popupContArray: [],
            popSession:false,
            dataEncode: null,
            testArray: [],

            showLoading: false,
            dataCheck: '',
            locationTicker: [],
            hanedleLocationTicker: [],
            location_ID: '',
            userAssets:  sessionStorage.getItem('USER_INFO'),
            login_Status: Cookies.get('login_status'),
            openPopAuthClick: false,
            profileData: '',
            historyData: null,
            checkTabVote: false,
            northVote: false,
            centralVote: false,
            northeastVote: false,
            easternVote: false,
            southVote: false,
            tabRegion: 'north',
            votesData:[],
            current_week: 1,
            winW :window.innerWidth,
            body:  document.querySelector('body'),
            playStatus: 0,
            popupVoteDup: false
            

        }
    },
    // computed: mapState(['travelListZone']),
    computed: {
        ...mapState(['travelListZone']),
        ...mapGetters(['loading']),

    },
    mounted() {
        if (this.body.getAttribute('data-end-campaign') != null) {
            this.activeTab = 'north';
        }
        this.$root.getProfile();

        document.title = 'แหล่งท่องเที่ยว Unseen New Chapters | Unseen New Chapters ปักหมุดใหม่ เปิดไทยมุมต่าง';
        setInterval(() => {
            if (sessionStorage.getItem('USER_INFO')) {
                const decodedDataString = atob(sessionStorage.getItem('USER_INFO'));
                const decodedArray = JSON.parse(decodedDataString);
                this.profileData = decodedArray.profile;
                this.historyData = decodedArray.history;
                this.current_week = 'week_' + decodedArray.history.current_week;
                this.initCheckTabVote();
            }
        }, 1000);
        // let intervalId = null;

        // Start the interval
        // intervalId = setInterval(() => {
        // if (this.$root.isCloseCampaign() == true) {
        //     this.profileData.credit_vote = 0;
        //     if (this.historyData.current_week < 1) {
        //     this.activateTab(this.historyData.current_week - 1);
        //     clearInterval(intervalId); // Stop the interval
        //     }
        // }
        // }, 5000);
     


        this.winW = window.innerWidth;
        window.addEventListener('resize', () => {
            this.winW = window.innerWidth;
        });
        // setTimeout(() => {
        //     // // console.log(this.travelListZone.zones);
        // }, 1000);
       if (!this.show) {
        this.body.removeAttribute('style');
       }
        if (this.login_Status == 1 ) {
            if (this.userAssets != null) {
                this.$root.getProfile();


                let decodedDataString = atob(this.userAssets);
                let decodedArray = JSON.parse(decodedDataString);

                this.profileData = decodedArray.profile;
                this.historyData = decodedArray.history;

                this.loginStatus = true;
                this.current_week = 'week_' + decodedArray.history.current_week;
                
                this.initCheckTabVote();
                // this.autoTab();
                if (this.body.getAttribute('data-end-campaign') != null) {
                    this.activeTab = 'north';
                }else{
                    this.autoTab();
                }

                window.addEventListener("storage", (event) => {
                    if (sessionStorage.getItem('USER_INFO') !== null|| sessionStorage.getItem('USER_INFO') !== undefined) {
                        let decodedDataString = atob(sessionStorage.getItem('USER_INFO'));
                        let decodedArray = JSON.parse(decodedDataString);
                        this.profileData = decodedArray.profile;
                        this.historyData = decodedArray.history;
                        this.current_week = 'week_' + decodedArray.history.current_week;
                        this.initCheckTabVote();
                        // // // console.log('sessionStorage change');
                    }
                });
                // cookieStore.addEventListener("change", (event) => {
                //     if (Cookies.get('login_status') == undefined) {
                //         sessionStorage.removeItem('USER_INFO');
                //         // // console.log('cookieStore change removeItem');
                //     }else{
                //         let decodedDataString = atob(sessionStorage.getItem('USER_INFO'));
                //         let decodedArray = JSON.parse(decodedDataString);
                //         this.profileData = decodedArray.profile;
                //         this.historyData = decodedArray.history;
                //         this.current_week = 'week_' + decodedArray.history.current_week;
                //         this.initCheckTabVote();
                //     }
                // });

            }
        }else{
            sessionStorage.removeItem('USER_INFO');
        }
        // Call API and start interval

        if (this.$route.query.slug != undefined || this.$route.query.slug != '' || this.$route.query.slug != null) {
            this.urlInitPopup(this.$route.query.slug);
        }
        
        // this.$store.dispatch('fetchZones');
       
        this.handleWindowFocus();
        // window.addEventListener('focus', this.handleWindowFocus);
        // window.addEventListener('blur', this.handleWindowBlur);
      

        setTimeout(() => {
            setFunction()
           
        }, 500);
        // window.addEventListener('load', () => {
           
          
        // });

      

         
        setTimeout(() => {
            var isloadeLoop =  setInterval(() => {
                // // // console.log(this.travelListZone.zones);
               
               try {
                    if(this.travelListZone.zones.length > 0 ||this.travelListZone.zones != ''){
                        if (document.querySelectorAll('.loadpage-com').length !== 0) {
                            document.querySelector('.loadpage-com').classList.remove('active')
                        }
                            setTimeout(() => {
                                this.isloade = false;
                                clearInterval(isloadeLoop);
                            }, 200);
                    }else{
                        this.isloade = true;
                    }
               } catch (error) {
                    if (document.querySelectorAll('.loadpage-com').length !== 0) {
                        document.querySelector('.loadpage-com').classList.remove('active')
                    }
                    setTimeout(() => {
                        this.isloade = false;
                        clearInterval(isloadeLoop);
                    }, 200);
               }
                
            }, 1000);
        }, 500);

        // this.playStatus = await this.$root.isCampaign();
        // // console.log(this.playStatus);

    },
    async created() {
        // this.playStatus = await this.$root.isCampaign();
        // setTimeout(() => {
        //         this.$root.getProfile();
        // }, 100);

        // mixer
        // setInterval(async () => {
        //     this.playStatus = await this.$root.isCampaign();
        //     // // console.log(this.playStatus);
        // }, 5000);
    },
    beforeUnmount() {
        clearInterval(this.intervalId);
        window.removeEventListener('focus', this.handleWindowFocus);
        window.removeEventListener('blur', this.handleWindowBlur);
    },
    methods: {
        replaceExtension(imageUrl) {
            return imageUrl.replace(/\.jpg$/, '.webp');
        },
        handleClick(name,value) {
            try {
                this.clickTracking(name,value);
            } catch (error) {
                
            }
            // Additional logic for handling the button click
        },

        handleVoteError(Error){
            // // console.log(Error);
            if (Error) {
                this.popupVoteDup =  Error;  
            }
            
        },
        handleVoteSuccess(success) {
            if (success) {
                this.isloadeApi = success;
              
            } else {
                this.isloadeApi = success
            }
        },
        handleSession(success){
            if (success) {
                this.popSession = success;
            } else {
                this.popSession = success
            }
        },
        handleVoteStart(success){
            if (success) {
                this.isloadeApi = success
            } else {
                this.isloadeApi = success
                
            }
        },
        handleVoteClicked(data) {
            const arrayClick = data;
            const isVotesData = [];
            isVotesData.push(arrayClick);
            this.handleVote(isVotesData[0].id,isVotesData[0].image_cover,isVotesData[0].location_name,isVotesData[0].province_th,isVotesData[0].region_th)
        },
        noDataFound(){
            let url = new URL(window.location.href);
            url.searchParams.delete('slug');
            window.history.replaceState(null, null, url.href);
        },
        // async urlInitPopup(slug) {
        //     const popUpIsslug = slug;
        //     if (popUpIsslug == undefined || popUpIsslug != '') {
        //         try {
        //             const response = await axios.get(`https://www.unseennewchapters.com/nx/API/get_locations/${popUpIsslug}`);
        //             // // // console.log(response.data);
        //             if (response.data.rs == true) {
        //                 this.handlePopContentClick(response.data.data.id,response.data.data.location,response.data.data.province_th,response.data.data.region_th,response.data.data.detail,response.data.data.image_cover,response.data.data.images,response.data.data.vote,response.data.data.region_en)
        //             }
        //             if (response.data.data.region_en != undefined) {
        //                 this.activateTab(response.data.data.region_en) 
        //             }
                    
                    
        //         } catch (error) {
        //         }
        //     }
        // },
        async urlInitPopup(slug) {
            const popUpIsslug = slug;
            if (popUpIsslug != undefined || popUpIsslug != '') {
                try {
                    const response = await axios.get(`https://www.unseennewchapters.com/nx/API/get_locations/${popUpIsslug}`);
                    // // // console.log(response.data);
                    // // // console.log(response.data.rs);
                    if (response.data.rs == true) {
                        this.handlePopContentClick(response.data.data.id,response.data.data.location_name,response.data.data.location,response.data.data.province_th,response.data.data.region_th,response.data.data.detail,response.data.data.image_cover,response.data.data.images,response.data.data.vote,response.data.data.region_en,response.data.data.tel,response.data.data.location_link)
                    }else{
                        this.noDataFound();
                    }
                    
                    if (response.data.data.region_en != undefined) {
                        this.activateTab(response.data.data.region_en) 
                    }
                } catch (error) {
                    this.noDataFound();
                }
            }else{
                this.noDataFound();
            }
                
        },

        
        fetchZones() {
            this.$store.dispatch('fetchZones');
            setFunction();
            this.updateDataRealTime();
            
        },
        handleWindowFocus() {
            
            this.fetchZones();
            // this.intervalId = setInterval(this.fetchZones, 20000);
        },
        handleWindowBlur() {
            clearInterval(this.intervalId);
        },

        activateTab(index) {
           
            this.activeTab = index;
            const container = this.$refs.tabList;
            setTimeout(() => {
                const activeElement = container.querySelector('.active');
            const scrollLeft = activeElement.offsetLeft + activeElement.offsetWidth / 2 - container.offsetWidth / 2;
            container.scrollTo({
                left: scrollLeft,
                behavior: 'smooth'
            });
            }, 50);
            
        },

//         tabRegionScroll(element){
//             // // console.log(element);
//             const container = element.$refs.tabList;
//             // // console.log(container);
//             setTimeout(() => {
//                 const activeElement = container.querySelector('.active');
//             // // console.log(activeElement);
//             }, 100);
           
//             const containerWidth = container.offsetWidth;
//             container.scrollTo({
//     left: scrollLeft,
//     behavior: 'smooth'
//   });
//         },
        afterVote(){
            // // console.log(this.$root);
            this.$store.dispatch('fetchZones');
            
            setTimeout(() => {
                this.updateData();
                setFunction();
            }, 100);
        },

        updateData() {
            this.$root.getProfile();
            if (sessionStorage.getItem('USER_INFO')) {
                const decodedDataString = atob(sessionStorage.getItem('USER_INFO'));
                const decodedArray = JSON.parse(decodedDataString);
                this.profileData = decodedArray.profile;
                this.historyData = decodedArray.history;
                this.current_week = 'week_' + decodedArray.history.current_week;
                this.initCheckTabVote();
            }
        },

        updateDataRealTime() {
            if (sessionStorage.getItem('USER_INFO')) {
                const decodedDataString = atob(sessionStorage.getItem('USER_INFO'));
                const decodedArray = JSON.parse(decodedDataString);
                this.profileData = decodedArray.profile;
                this.historyData = decodedArray.history;
                this.current_week = 'week_' + decodedArray.history.current_week;
                this.initCheckTabVote();
            }
        },

        handlePopContentClick(id,location_name,location,province_th,region_th,detail,image_cover,images,vote,region_en,tel,location_link) {
            this.show = true;
            this.popupContArray=[{
                id:id ,location_name:location_name,location:location,province_th:province_th,region_th:region_th,detail:detail,image_cover:image_cover,images:images,vote:vote,region_en:region_en,tel:tel,location_link:location_link
            }]
            window.history.pushState(null, null, `?slug=${id}`);

        },
        // ...mapActions('voteStoreData', ['updateData']),
        handleVote(locationId,imageCover,location_name,location_province_th,location_region_th) {
            
            this.userAssets = sessionStorage.getItem('USER_INFO');
            if (this.userAssets == null || this.userAssets == '') {
                try {
                    document.getElementById('registerbtn').click();
                    this.handleClick('Auth','login-vote');

                } catch (error) {
                    document.getElementById('registerbtn').click();
                }


            } else {
                this.voteShow = true;
                this.location_ID = locationId;
               
                this.locationTicker = [{
                    location_ID: locationId,
                    imageCover:imageCover,
                    location_name:location_name,
                    location_province_th:location_province_th,
                    location_region_th:location_region_th,
                }]
                
            }
        },
        
        
        autoTab() {
            const tabRegions = this.historyData[this.current_week];
            if (!tabRegions.hasOwnProperty('north')) {
                    this.tabRegion = 'north';
                    this.activateTab(this.tabRegion );
                } else if (!tabRegions.hasOwnProperty('central')) {
                    this.tabRegion = 'central';
                    this.activateTab(this.tabRegion );
                } else if (!tabRegions.hasOwnProperty('northeast')) {
                    this.tabRegion = 'northeast';
                    this.activateTab(this.tabRegion );
                } else if (!tabRegions.hasOwnProperty('eastern')) {
                    this.tabRegion = 'eastern';
                    this.activateTab(this.tabRegion );
                } else if (!tabRegions.hasOwnProperty('south')) {
                    this.tabRegion = 'south';
                    this.activateTab(this.tabRegion);
                }
            
            
            this.$store.dispatch('fetchZones');
            setTimeout(() => {
                setFunction()
            }, 100);
        },
        isVote(locationEN) {
                const tabRegions = this.historyData;
                if (tabRegions != null) {
                    return tabRegions[ this.current_week].hasOwnProperty(locationEN) ? true : false;
                }
                
        },
        itemVote(index,locationId){
            const itemVote = this.historyData;
            if (itemVote != null) {
                if (itemVote[ this.current_week].hasOwnProperty(index)) {
                    if (itemVote[ this.current_week][index][0].location_id == locationId) {
                        return true
                    }
                }
            }
          
        },
        initCheckTabVote() {
            const votedRegions = this.historyData;
            if (votedRegions != null) {
                    this.northVote =  votedRegions[this.current_week].hasOwnProperty('north');
                    this.centralVote =  votedRegions[this.current_week].hasOwnProperty('central');
                    this.northeastVote =  votedRegions[this.current_week].hasOwnProperty('northeast');
                    this.easternVote =  votedRegions[this.current_week].hasOwnProperty('eastern');
                    this.southVote =  votedRegions[this.current_week].hasOwnProperty('south');   
                }
           
            
        },


    }
}
</script>

<style>
.swiper-container {
    width: 100%;
    height: 100%;
}


h3.font-display.font-second{margin-top: -20px;}

.swiper-slide img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}



.popup {
    position: fixed;
    z-index: 9999;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
}

.popup-content {
    background-color: #fff;
    padding: 20px;
    border-radius: 4px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
    max-width: 500px;
    width: 100%;
}

.row {
    display: flex;
    flex-wrap: wrap;
}

.col-left {
    flex: 0 0 150px;
    margin-right: 20px;
}

.col-right {
    flex: 1;
    overflow: auto;
    /* Add scrollbar to right column */
}

.col-left img {
    width: 100%;
    height: auto;
}

.popup-content h2 {
    margin-top: 0;
}

.popup-content p {
    margin-bottom: 20px;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.popup-content.show .fade-enter {
    opacity: 1;
}

.bg-77vote {
    background-image: url(../assets/img/77-attractions/banner-77-travel.webp);
}

.v-enter-active,
.v-leave-active {
    transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
    opacity: 0;
}


.fade-enter-active,
.fade-leave-active {
    transition: opacity .5s;
}


.v-enter-active,
.v-leave-active {
    transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
    opacity: 0;
}


.fade-enter-active,
.fade-leave-active {
    transition: opacity .5s;
}

/* .fade-enter, .fade-leave-active {
  opacity: 0;
} */

.pop-img {
    margin-top: -50px;
    width: 100%;
    text-align: center;
}

.isvote .card-like{pointer-events: none;}
.isvote .card:not(.itemIsVote) .card-like svg{fill: #B1B1B1;}
.isvote .card:not(.itemIsVote) .card-like svg path{fill: #B1B1B1 !important;}
.isvote .card:not(.itemIsVote) .card-like {color: #B1B1B1;background-color: #E2E2E2;border: 2px solid #E2E2E2;}

.isvote .itemIsVote .card-like svg{fill: #fff;}
.isvote .itemIsVote  .card-like svg path{fill: #fff !important;}
.isvote .itemIsVote .card-like {color: #fff;background-color: var(--color-primary);}


@media (max-width: 991.98px){
    .tmr-l-1 {
    font-size: 1.2em;
    }
    .tmr-l-2 {
        font-size: 1em;
    }
    .tmr-c {
        font-size: 3.5em;
    }
    .vote77 .tab-list a{font-size:0.9em;}
    .sec-banner-main {
    height: 370px;
    background-size: cover;
}
   
    .tab-my-rights{padding: 15px 10px;}
   
}
@media (max-width: 767.98px){
    .tab-my-rights{display: none;}
    .sec-attractions.bg-77vote {
        background-image: url(../assets/img/77-attractions/banner-77-travel-m.webp);
    }

    .bg-77vote .box-title {
        margin-top: -80px;
    }
    .st.sec.vote77 {
        padding: 0;
        margin-top: -90px;
    }

    .vote77 .sec-tab ul{width: calc(100% + 20px); margin-left: -20px;padding-left:20px}
    .sec-attractions.sec-banner-main {height: 370px;}
    .vote77 .sec-tab{overflow: hidden;}

}
@media (max-width: 575.98px){
   
    .sec-attractions.sec-banner-main {height: 260px;}
    .st.sec.vote77{padding-bottom: 40px;}
}

</style>
